import { render, staticRenderFns } from "./ConfirmAnswer.vue?vue&type=template&id=166cb09a&scoped=true&"
import script from "./ConfirmAnswer.vue?vue&type=script&lang=ts&"
export * from "./ConfirmAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmAnswer.vue?vue&type=style&index=0&id=166cb09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166cb09a",
  null
  
)

export default component.exports